import { create } from "zustand";
import { generateUUID } from "utils/uuid";

export enum NotificationType {
  SUCCESS = "SUCCESS",
  INFO = "INFO",
  ERROR = "ERROR",
}

export interface NotificationModel {
  uuid: string;
  type: "SUCCESS" | "INFO" | "ERROR";
  title: string;
  message?: string;
}

export interface NotificationStateModel {
  items: NotificationModel[];
}

interface NotificationStore extends NotificationStateModel {
  addNotification: (type: NotificationType, title: string, message?: string) => void;
  hideNotification: (uuid: string) => void;
  successNotification: (title: string, message?: string) => void;
  errorNotification: (title: string, message?: string) => void;
}

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  items: [],

  addNotification: (type, title, message?) => {
    const uuid = generateUUID();
    const item: NotificationModel = { uuid, type, title };
    if (message) item.message = message;

    set((state) => ({ items: [...state.items, item] }));

    setTimeout(() => {
      get().hideNotification(uuid);
    }, 4000);
  },

  hideNotification: (uuid) => {
    set((state) => ({
      items: state.items.filter((n) => n.uuid !== uuid),
    }));
  },

  successNotification: (title, message?) => {
    get().addNotification(NotificationType.SUCCESS, title, message);
  },

  errorNotification: (title, message?) => {
    get().addNotification(NotificationType.ERROR, title, message);
  },
}));
